import {CPSConstants} from "commonUtils/enumerations";

export interface trainingResonseProps {
  isTrainingCPSOverviewCompleted: boolean;
  isTrainingMarketingMedicalCompleted: boolean;
  isTrainingDiscoveryMedicalCompleted: boolean;
  isTrainingApproversCompleted: boolean;
  userTrainingDetails: userTrainingDetailsProps;
  userTrainingCategories: userTrainingCategoriesType[];
  messageCode?: number;
  message?: string | null;
  isSuccessMessage?: boolean;
  isErrorMessage?: boolean;
  isValidationMessage?: boolean;
}
export interface trainingDataProps {
  CompletedDate: string | null;
  isTraining: boolean;
  id: number;
  isSubCategory: boolean;
  subCategory: string[];
  displayText: string;
  isChecked: boolean;
}

export interface userTrainingDetailsProps {
  mostRecentCPSOverviewCompletedDate?: Date | null;
  mostRecentMarketingCompletedDate?: Date | null;
  mostRecentMedicalCompletedDate?: Date | null;
  mostRecentApproversCompletedDate?: Date | null;
  isTrainingCPSOverviewCompleted: boolean;
  isTrainingMarketingMedicalCompleted: boolean;
  isTrainingDiscoveryMedicalCompleted: boolean;
  isTrainingApproversCompleted: boolean;
}
export interface userTrainingCategoriesType {
  id: number;
  isSubCategory: boolean;
  displayText: string;
  CompletedDate?: string;
  isTraining?: boolean;
  isChecked?: boolean;
}

export interface PostTrainingProps {
  userId: number;
  profileId: number;
  isTrainingCPSOverviewCompleted: boolean;
  isTrainingMarketingMedicalCompleted: boolean;
  isTrainingDiscoveryMedicalCompleted: boolean;
  isTrainingApproversCompleted: boolean;
}

export interface FilterTrainingStatus {
  id: number;
  isSubCategory: boolean;
  displayText: string;
  CompletedDate: string;
  isTraining: boolean;
  isChecked: boolean;
}

export const trainingDialogStyle = {
  gridContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginTop: "0.2rem",
  },
  gridItem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginTop: "0.2rem",
  },
  dialogContent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0px 24px 20px 24px",
  },
  TableRowParent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "0.7rem",
    fontWeight: "bold",
  },
  TableRowChild: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "0.6rem",
    fontWeight: "700",
  },
  TableCellStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "1.2rem",
    fontWeight: "bold",
  },
  dateTraining: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "0.8rem",
    fontWeight: CPSConstants.FONTWEIGHT,
  },
  headerTextStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "0.8rem",
    fontWeight: CPSConstants.FONTWEIGHT,
    color: "#000000",
  },
  linkclick: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textAlign: "center",
    fontSize: "1.3rem",
    fontWeight: CPSConstants.FONTWEIGHT,
  },
  linkclickhere: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0 5px",
    fontSize: "1.3rem",
    textDecoration: "none",
    fontWeight: CPSConstants.FONTWEIGHT,
    "&:hover": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      textDecoration: "underline",
    },
  },
  trainingButton: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "right",
  },
  trainingMuiBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
  },
  tableBorder: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1px solid #C4C2C2",
  },
  tableCellBorder: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderBottom: "1px dashed #BCB8B8",
  },
  tableCellOne: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: "#C1EA94",
  },
  tableCellTwo: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: "#C1EA94",
    width: "25rem",
  },
  tableCellThree: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: "#C1EA94",
    width: "16rem",
  },
  trainingCheckBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiSvgIcon-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: "2rem",
    },
  },
};
